import { updateHomePageCategoryMutation } from '../../lib/graphql';
import showToaster from '../../helpers/toastrMessgaes/showToaster';
import history from '../../history';
import { setLoaderComplete, setLoaderStart } from '../loader/loader';

export const updateHomePageCategory = ({ categoryList }) => {

    try {

        let title, description;
        title = categoryList?.title[0]?.title;
        description = categoryList?.title[0]?.description;

        return async (dispatch, getState, { client }) => {

            dispatch(setLoaderStart('CategoryForm'))

            const { data } = await client.mutate({
                mutation: updateHomePageCategoryMutation,
                variables: {
                    homePageCategoryList: {
                        id: categoryList?.id,
                        title,
                        description,
                        logo: categoryList?.logo,
                        banner: categoryList?.banner,
                    },
                    dynamicTopFeatureSettings: categoryList?.title
                }
            });

            dispatch(setLoaderComplete('CategoryForm'))
            if (data?.updateHomePageCategory?.status == 200) {
                showToaster({ messageId: 'updateHomeSuccess', toasterType: 'success' });
                history.push('/siteadmin/homepage/top-feature');
            }
            else {
                showToaster({ messageId: 'errorMessage', requestContent: data?.updateHomePageCategory?.errorMessage, toasterType: 'error' });
            }
        };
    }
    catch (error) {
        showToaster({ messageId: 'catchMessage', requestContent: error, toasterType: 'error' });
    }
}